export default __webpack_public_path__ + "static/media/PolySansTrial-Neutral.ab0da5a5.otf";